import React, { useState, useEffect } from "react";
import Constants from 'expo-constants';
import {
  Platform,
  StyleSheet,
  Text,
  Image,
  Button,
  TextInput,
  View,
  TouchableOpacity,
  SafeAreaView
} from "react-native";
import { StatusBar } from 'expo-status-bar';

import { NavigationContainer, useNavigation } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { MaterialIcons } from '@expo/vector-icons';
import { DefaultTheme, Provider as PaperProvider } from 'react-native-paper';
import AsyncStorage from '@react-native-async-storage/async-storage';


import {
  MenuScreen,
  ProfileScreen,
  DisciplinesScreen,
  RatingScreen,
  FinalTestScreen,
  FinalTestResultScreen,
  BMIScreen,
  BMIResultScreen,
  AuthorScreen,
  GroupsScreen,
  DefinitionsScreen
} from "./src/screens"

import { COLORS, IMAGES } from "./src/constants";
import { 
  OutlineBtnHeader, 
  LeftBackBtn, 
  ProfileMiniMenu,
  ResetBtnHeader
 } from "./src/components";

const Stack = createNativeStackNavigator();

const theme = {
  ...DefaultTheme,
  roundness: 2,
  colors: {
    ...DefaultTheme.colors,
    primary: COLORS.accent,
    accent: COLORS.primary,
    background: COLORS.background,
    text: COLORS.primary

  },
};

// const Stack = createNativeStackNavigator(){
//   stack: {
//     screen: 'Welcome',
//     navigationOptions: {customNavigationOptions}
//   }
// };

export default function App() {

  function LogoTitle() {
    return (
      <Image
        style={{ width: 36, height: 36 }}
        source={IMAGES.favIcon}
      />
    );
  }

  const customNavigationOptions = ({ navigation }) => {
    return {
      headerLeft: () => (
        <LeftBackBtn onPress={() => { navigation.goBack() }} />
      ),
      headerStyle: { elevation: 0 },
      cardStyle: { backgroundColor: COLORS.accent },
      // headerLeft: null,
      headerTintColor: COLORS.primary,
      contentStyle: {
        backgroundColor: COLORS.background,
      },
      headerStyle: {
        backgroundColor: COLORS.background,
        borderBottomColor: COLORS.accent,
        borderBottomWidth: 1,
      },
      headerTitleStyle: {
        color: COLORS.primary,
        fontSize: 24,
        fontWeight: 'bold'
      }
    }
  }

  return (
    <SafeAreaView style={styles.container}>
    <PaperProvider theme={theme}>
    <StatusBar style="light" hidden="true" backgroundColor={COLORS.background} />

      <NavigationContainer>
        <Stack.Navigator
          initialRouteName='Welcome'
          screenOptions={customNavigationOptions}
        >
          <Stack.Screen
            name="Welcome"
            component={MenuScreen}
            options={{
              title: 'Sprawdzian',
              headerRight: () => (
                <OutlineBtnHeader text="Ustawa" />
              ),
              // headerTitle: (props) => <LogoTitle {...props} />
            }}
          />
          <Stack.Screen
            name="FinalTest"
            component={FinalTestScreen}
            options={{
              title: 'EGZAMIN',
              // headerRight: () => (

              //   <OutlineBtnHeader />

              // ),
              // headerTitle: (props) => <LogoTitle {...props} />
            }}
          />
          <Stack.Screen
            name="FinalTestResult"
            component={FinalTestResultScreen}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Profile"
            component={ProfileScreen}
            options={{
              // title: 'Moje dane',
              title: 'PROFIL',
              headerRight: () => (
                <ProfileMiniMenu text="test" />
              ),
            }}
          />
          <Stack.Screen
            name="Disciplines"
            component={DisciplinesScreen}
            options={{
              // title: 'Moje konkurencje',
              title: 'KONKURENCJE',
            }}
          />
          <Stack.Screen
            name="BMI"
            component={BMIScreen}
            options={{
              // title: 'Moje konkurencje',
              title: 'BMI (Body mass index)',
            }}
          />
          <Stack.Screen
            name="BMIResult"
            component={BMIResultScreen}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Author"
            component={AuthorScreen}
            options={{
              title: 'AUTOR',
              headerRight: () => (
                <OutlineBtnHeader text="Wsparcie" />
              ),
            }}
          />
          <Stack.Screen
            name="Groups"
            component={GroupsScreen}
            options={{
              // title: 'Moje konkurencje',
              title: 'Podział żołnierzy',
            }}
          />
          <Stack.Screen
            name="Rating"
            component={RatingScreen}
            options={{
              // title: 'Moje konkurencje',
              title: 'Punktacja',
            }}
          />
          <Stack.Screen
            name="Definitions"
            component={DefinitionsScreen}
            options={{
              // title: 'Moje konkurencje',
              title: 'Opisy konkurencji',
            }}
          />


        </Stack.Navigator>
      </NavigationContainer>
    </PaperProvider>
    </SafeAreaView>
  )

}

const styles = StyleSheet.create({
  container: {
    // paddingTop: Constants.statusBarHeight,

    // alignItems: 'center',
    // justifyContent: 'center',
    // padding: Platform.OS === "ios" ? 40 : StatusBar.currentHeight + 10,
    flex: 1,
    // backgroundColor: COLORS.background,
    // padding: SIZES.padding,
  }
});
